import { render, staticRenderFns } from "./DhivehiTextArea.vue?vue&type=template&id=4655bf53"
import script from "./DhivehiTextArea.vue?vue&type=script&lang=js"
export * from "./DhivehiTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports